import React from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import AdminChangeUserProxyComponent from "../../../components/Admin/proxies/AdminChangeUserProxyComponent";

const AdminChangeUserProxyPage = () => {
    const { search } = useLocation();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    return <AdminChangeUserProxyComponent
        redirectBack={ () => redirectBack() }
        listId={ new URLSearchParams(search).get('listId') }
    />
}

export default AdminChangeUserProxyPage;